<template>
    <div>
        <div class="container  h-300" style="padding: 5% 0;">
            <div class="justify-content-center h-100 valign"  v-if="onProcess">
                <h4 class="center">Memproses Permintaan Anda</h4>
            </div>
            <img class="img" src="~@/assets/images/2.gif"  v-if="onProcess">
        </div>
    </div>
</template>

<script>
    import swal from "sweetalert";
    export default {
        name: "approveProductAdjustment",
        data() {
            return {
                onProccess: false,
                isSuccess : null,
            };
        },
        methods: {
            toPage(e) {
                // this.$router.push(e);
                this.$router.push({
                    path: '/rental/product',
                    query: {
                    companyName: '',
                    productBrand: '',
                    productModel: '',
                    productCode:'',
                    productType: 'All',
                    productTypeName: 'All',
                    productStatus: 'All',
                    productStatusName: 'All',
                    startRentFrom: '',
                    startRentTo: '',
                    endRentFrom: '',
                    endRentTo: '',
                    itemPerPage: 10,
                    page: 1
                    }
                })
            },
            showResult() {
                if(this.isSuccess !== null) {
                    if(this.isSuccess) {
                        swal({
                            title: 'Success', 
                            text: 'Berhasil', 
                            icon: 'success',
                            closeOnEsc: false,
                            allowOutsideClick: false,
                        }).then(() => {
                            this.toPage('/')
                        });
                    } else {
                        swal('Failed', 'Gagal', 'error').then(() => {
                            this.toPage('/')
                        });
                    }
                } 
            },
            approveChange() {
                this.onProcess = true
                
                const {toPage} = this
                let {onProcess} = this
                let location = window.location.pathname.split('/')
                const accessToken = location[location.length - 1]

                this.$http.post(`${process.env.APPROVE_TICKET_PRODUCT_RENTING_ADJUSTMENT_EMAIL}`,
                    {
                        headers: {'Asani-Token':localStorage.getItem('jwt')}
                    },
                    {
                        params : {tokenAccess : accessToken }
                    })
                    .then(response => {
                    if (response.data.status !== 200) {
                        this.isSuccess = false
                        this.showResult()
                    } else{
                        this.isSuccess = true
                        this.showResult()
                    }
                    this.onProcess = false
                })
                .catch(error => {
                    swal("Sorry", error.message, "error", {
                        button: "Close",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                        this.handleLogout()
                        } else {
                            this.toPage('/')
                        }
                    })
                })
            },
            async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
                localStorage.removeItem('jwt')
                localStorage.removeItem('admin_name')
                localStorage.removeItem('roles')
                localStorage.removeItem('user_email')
                localStorage.removeItem('admin_id')
                localStorage.removeItem('changeCatalogPermission')
                this.$router.push('/')
            }
        },
        created() {
            this.approveChange();
        }
    };
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    /* Coded with love by Mutiullah Samim */
    body,
    html {
      margin: 0;
      padding: 0;
      height: 100%;
      background: #60a3bc !important;
    }

    .valign{
      vertical-align: middle;
      margin-top: 150px;
      margin-bottom: 15px;
    }

    .center{
        text-align: center;
    }

    img {
        display: block;
        margin-left: auto;
        margin-right: auto;
    }

    @media(max-width: 991px){
      .brand_logo_container_top {
      margin-top: 110px;
      margin-right: 50px;
      display: none;
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/Order/ApproveProductAdjustmentPage.vue